import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    back: 'Back',
    details: {
      desktop: 'See plan details',
      mobileLine1: 'Do you need more details? ',
      mobileLine2: 'See our website',
    },
    help: 'Help',
    questions: [
      {
        content:
          'Your subscription starts immediately if your account is open. If not, it will start once your account is validated.',
        title: 'When does my subscription start?',
      },
      {
        content:
          'Downgrading to Shine Basic costs €50 for the first 6 months, then free at the end of this period. You can go back to others plans at any time for free.',
        title: 'Can I change my mind?',
      },
    ],
    title: 'Select your offer',
  },
  fr: {
    back: 'Précédent',
    details: {
      desktop: 'Voir les détails',
      mobileLine1: 'Vous avez besoin de plus de détails ?',
      mobileLine2: 'Consultez notre site',
    },
    help: 'Aide',
    questions: [
      {
        content:
          'Votre abonnement démarre immédiatement si votre compte est ouvert. Sinon, il démarrera quand votre compte sera validé.',
        title: 'À quel moment démarre mon abonnement ?',
      },
      {
        content:
          'Le retour à Shine Basic est facturé 50 € au cours des 6 premiers mois, puis sans frais après cette période. Vous pouvez retourner aux autres plans à tout moment sans frais.',
        title: 'Est-ce que je peux changer d’avis ?',
      },
    ],
    title: 'Choisissez votre offre',
  },
} as const);
